import { Duration } from "luxon";
import { ManagedReceivingPartnerApi as Api } from "@capstone/mock-api";
import { Site } from "src/app/core/sites";
import { TimeOfDay } from "src/app/core/time-of-day.model";
import { Weekdays } from "src/app/core/weekdays.model";
import { getApiDetailsDecorator } from "src/utils";
import { DockGroup } from "./dock-group.model";

const api = getApiDetailsDecorator<Api.DockUpdate>();

export abstract class BaseDock {
  protected constructor(args: ClassProperties<BaseDock>) {
    this.address = args.address;
    this.appointmentInterval = args.appointmentInterval;
    this.earlyScheduleThreshold = args.earlyScheduleThreshold;
    this.gatePassMessage = args.gatePassMessage;
    this.group = args.group;
    this.isActive = args.isActive;
    this.isDockLevelSettingEnabled = args.isDockLevelSettingEnabled;
    this.isReservationSlotsOutsideOfHourlyCapacityTimeWindowPresented =
      args.isReservationSlotsOutsideOfHourlyCapacityTimeWindowPresented;
    this.isReservationsInThreshold = args.isReservationsInThreshold;
    this.lateScheduleThreshold = args.lateScheduleThreshold;
    this.maximumAppointmentDuration = args.maximumAppointmentDuration;
    this.minimumAppointmentDuration = args.minimumAppointmentDuration;
    this.name = args.name;
    this.scheduleCutoffTime = args.scheduleCutoffTime;
    this.site = args.site;
    this.weekdays = args.weekdays;
  }

  @api() public readonly address: string | null;
  @api() public readonly appointmentInterval: Duration | null;
  @api() public readonly earlyScheduleThreshold: number;
  @api() public readonly gatePassMessage: string | null;
  @api({ key: "dockGroupID" }) public readonly group: DockGroup;
  @api({ key: "active" }) public readonly isActive: boolean;
  @api({ key: "enableDockLevelSetting" })
  public readonly isDockLevelSettingEnabled: boolean | null;
  @api({ key: "reservationsInThreshold" })
  public readonly isReservationsInThreshold: boolean;
  @api({ key: "presentReservationSlotsOutsideHourlyCapacityTimeWindow" })
  public readonly isReservationSlotsOutsideOfHourlyCapacityTimeWindowPresented: boolean;
  @api() public readonly lateScheduleThreshold: number;
  @api({ key: "maxAppointmentDuration" })
  public readonly maximumAppointmentDuration: Duration | null;
  @api({ key: "minimumUnloadMinutes" })
  public readonly minimumAppointmentDuration: Duration | null;
  @api() public readonly name: string;
  @api() public readonly scheduleCutoffTime: TimeOfDay | null;
  @api({ key: "siteID" }) public readonly site: Site;
  @api({ key: "daysOfWeek" }) public readonly weekdays: Weekdays;
}
